import { calculateDailyBudget, calculateTotalBudget, round } from '@albacross/frontend-utils'

const calculateTotalByGI = (gi, cpm) => (gi * cpm) / 1000

export const updateValues = (field, initialValues) => {
  const values = { ...initialValues }
  const dates = [values.startDate, values.endDate]

  const totalBudget =
    field !== 'totalBudget'
      ? field === 'goalImpressions'
        ? calculateTotalByGI(values.goalImpressions, values.cpm)
        : calculateTotalBudget(values.dailyBudget, dates as any)
      : values.totalBudget

  const dailyBudget = !['dailyBudget', 'endDate', 'startDate'].includes(field)
    ? calculateDailyBudget(totalBudget, dates as any)
    : values.dailyBudget

  const goalImpressions =
    field !== 'goalImpressions' ? Number(round((totalBudget / values.cpm) * 1000)) : values.goalImpressions

  const extraViewsPercent =
    field === 'goalRtbImpressions'
      ? (((values.goalRtbImpressions - goalImpressions) / goalImpressions) * 100).toFixed(2)
      : values.extraViewsPercent

  const goalRtbImpressions =
    field !== 'goalRtbImpressions'
      ? Number(round(goalImpressions * (1 + extraViewsPercent / 100)))
      : values.goalRtbImpressions

  return {
    ...values,
    totalBudget,
    dailyBudget,
    goalImpressions,
    goalRtbImpressions,
    extraViewsPercent,
  }
}

// Editing any of these recomputes the derived budget fields (consumed with updateValues by useCampaignDerivedFields).
export const SOURCE_FIELDS = [
  'dailyBudget',
  'startDate',
  'endDate',
  'cpm',
  'totalBudget',
  'goalImpressions',
  'goalRtbImpressions',
]
